/* eslint-disable no-useless-constructor */
import feathersClient, { BaseModel, makeServicePlugin } from "../../feathers-client";

class MISORealTimePrices extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "MISORealTimePrices";
}

const servicePlugin = makeServicePlugin({
  Model: MISORealTimePrices,
  service: feathersClient.service("data-services/miso/real-time-locational-marginal-prices"),
  idField: "_id",
  nameStyle: "path",
  getters: {},
});

export default servicePlugin;
